import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "triple-select mr-2" }
const _hoisted_2 = { class: "double-select mr-2" }
const _hoisted_3 = { class: "uppercase text-raleway-13" }

import { computed, onBeforeMount, ref } from "vue";
import { ChedulesDetails } from "@/store/modules/accountDetails/type";
import { Locations } from "@/store/modules/Locations/type";
import { IStore } from "@/store/types/StoreType";
import { Field } from "vee-validate";
import { useStore } from "vuex";

import CountryComponent from "./country/countryComponent.vue";
import PostalcodeComponent from "./postalcode/postalcodeComponent.vue";
import RegionComponent from "./region/regionComponent.vue";
import CityComponent from "./city/cityComponent.vue";
import { store } from '../../../store/index';


export default /*#__PURE__*/_defineComponent({
  __name: 'addressStockComponent',
  props: {
    errors: {},
    values: {}
  },
  setup(__props: any) {

const props = __props;

const locationSelected = ref(
  computed<Locations[]>(() => store.getters.getStockLocationsInSelectedAddress)
);

const store = useStore<IStore>();



onBeforeMount(() => {
  store.dispatch("getCountryStockPostalcode");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(CountryComponent, {
        error: props.errors.country_stock
      }, null, 8, ["error"]),
      _createVNode(PostalcodeComponent, {
        error: props.errors.postal_code_stock
      }, null, 8, ["error"]),
      _createVNode(RegionComponent, {
        error: props.errors.region_stock
      }, null, 8, ["error"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(CityComponent, {
        error: props.errors.city_stock
      }, null, 8, ["error"]),
      _createElementVNode("div", {
        class: _normalizeClass({ 'error-input mini': !!props.errors?.buyer_address_stock })
      }, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$tc("Address")), 1),
        _createVNode(_unref(Field), {
          tabindex: 19,
          type: "text",
          name: "buyer_address_stock",
          maxlength: "55",
          class: "input input-mini",
          values: _ctx.values?.buyer_address_stock,
          placeholder: (locationSelected.value || [])[0]?.full_address || ''
        }, null, 8, ["values", "placeholder"])
      ], 2)
    ])
  ], 64))
}
}

})